import { camelCaseify } from '../../../utils'

interface Chef {
  id: string
  email: string
  phoneNumber: string
  name: string
  firstName: string
  lastName: string | null
  pickupAddress: string | null
  minCateringPayout: number
  processingFee: string
  optInUniversalPricingAgreement: boolean
  payToName: string | null
}

export const LoadIndexChefsByIds =
  ({ RestService }: { RestService: any }) =>
  async (chefIds: string[]): Promise<Chef[]> => {
    const chefs = await RestService.get('/api/admin/chefs', {
      ids: chefIds.join(','),
    })

    return camelCaseify(chefs)
  }
